<template>
  <div :class="lucking.location.box_name + ' pointer'">
    <div class="header">
      <div class="header-text">
        {{ lucking.location.sub_title }}
      </div>
    </div>
    <div class="content">
      <div id="product-list" class="product-list">
        <div class="product-box">
          <div class="product-item" :style="getGridItemStyle(1, 0)"></div>
          <div class="product-item" :style="getGridItemStyle(1, 1)"></div>
        </div>
        <div class="product-box">
          <div class="product-item" :style="getGridItemStyle(2, 0)"></div>
          <div class="product-item" :style="getGridItemStyle(2, 1)"></div>
        </div>
        <div class="product-box">
          <div class="product-item" :style="getGridItemStyle(3, 0)"></div>
          <div class="product-item" :style="getGridItemStyle(3, 1)"></div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="button pointer" :style="getLotteryButtonStyle()">
        <img @click="clickLucking" src="http://vw-assets.welltuo.com/images/none-3-1.png" class="w100" />
      </div>
    </div>
    <template v-if="iconList[lucking.location.box_name] && iconList[lucking.location.box_name].twinkle">
      <div :class="'lucking-icon icon-' + icon + (idx % 2 === 0 ? ' twinkle-' + lucking.location.icon_twinkle_speed: ' twinkle-un-' + lucking.location.icon_twinkle_speed)" v-for="(icon, idx) in iconList[lucking.location.box_name].twinkle" :key="'twinkle-' + idx"></div>
    </template>
    <template v-if="iconList[lucking.location.box_name] && iconList[lucking.location.box_name].basics">
      <div :class="'lucking-icon icon-' + icon" v-for="(icon, idx) in iconList[lucking.location.box_name].basics" :key="'basics-' + idx"></div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'LuckingGrid',
  props: {
    lucking: {
      type: Object
    },
    productList: {
      type: Object
    },
    iconList: {
      type: Object
    },
    runLucking: {
      type: Function
    }
  },
  data () {
    return {
      gridHeight: null,
      isLucking: false,
      nowLuckIdx: 0,
      nowLuckTop: 0,
      nowItem: 0,
      luckHeigth: null,
      confirmLuck: null,
      imageList: []
    }
  },
  watch: {
    'productList': function () {
    }
  },
  methods: {
    setLucking (val) {
      if (val === null) {
        this.confirmLuck = this.imageList.length - 1
        this.isLucking = false
      } else {
        var pId = this.imageList.length - 1
        var idx = 0
        for (var key in this.productList) {
          if (this.productList[key].id === val) {
            pId = idx
          }
          idx++
        }
        this.confirmLuck = pId
        this.isLucking = false
      }
    },
    goNowLuck () {
      setTimeout(() => {
        if (this.luckHeigth + this.nowLuckTop <= 0) {
          this.nowLuckTop = 0
          this.nowLuckIdx++
          this.nowItem++
          if (this.nowItem > 2) {
            this.nowItem = 1
          }
        } else {
          this.nowLuckTop -= 10
        }

        if (this.confirmLuck === this.nowLuck || this.confirmLuck === 999) {
          if (this.confirmLuck === 999) {
            this.nowLuck = 99
          }
        } else {
          if (this.isLucking) {
            this.goNowLuck()
          }
        }
      }, 5)
    },
    clickLucking () {
      this.confirmLuck = null
      this.isLucking = true
      this.nowLuckIdx = 0
      this.nowLuckTop = 0
      this.nowItem = 0
      this.luckHeigth = document.getElementById('product-list').clientHeight
      this.goNowLuck()
      this.$props.runLucking()
    },
    getLotteryButtonStyle () {
      var style = 'display: flex;'
      style += 'background-image: url(' + this.lucking.location.lottery_button + ');'
      style += 'background-repeat: no-repeat;'
      style += 'background-position: center center;'
      style += 'background-size: contain;'
      return style
    },
    getProductIdx () {
      var idx = 0
      for (var key in this.productList) {
        if (this.productList[key].id === this.nowLuck) {
          return idx
        }
        idx++
      }
      return '_thank_coming_'
    },
    getGridItemStyle (idx, number) {
      var style = 'display: flex;'
      var _idx = idx - 1 + number + this.nowLuckIdx
      if (_idx > this.imageList.length) {
        _idx = _idx % this.imageList.length
      }
      if (this.confirmLuck !== null && !this.isLucking) {
        _idx = this.confirmLuck
      }

      style += 'background-image: url(' + this.imageList[_idx] + ');'
      style += 'background-repeat: no-repeat;'
      style += 'background-position: center center;'
      style += 'background-size: contain;'
      if (!this.isLucking) {
        if (number > 0) {
          style += 'top: ' + (this.luckHeigth * number) + 'px;'
        }
      }
      if (this.isLucking) {
        var nowLuckTop = this.nowLuckTop + (this.luckHeigth / 4)
        if (this.nowItem === number) {
          style += 'top: ' + nowLuckTop + 'px;'
        } else {
          var heigth = (number - 1) * (this.luckHeigth / 2)
          style += 'top: ' + (nowLuckTop + heigth) + 'px;'
        }
      }
      return style
    },
    refImageList () {
      var imageList = []
      for (var key in this.productList) {
        imageList.push(this.productList[key].image)
      }
      imageList.push(this.lucking.location.thank_coming)
      this.$set(this, 'imageList', imageList)
    }
  },
  mounted () {
    this.refImageList()
    this.luckHeigth = document.getElementById('product-list').clientHeight
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lucking/slotMachine.vue